import { render, staticRenderFns } from "./MapCollection.vue?vue&type=template&id=05b71b3d&scoped=true&"
import script from "./MapCollection.vue?vue&type=script&lang=js&"
export * from "./MapCollection.vue?vue&type=script&lang=js&"
import style0 from "./MapCollection.vue?vue&type=style&index=0&id=05b71b3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b71b3d",
  null
  
)

export default component.exports